var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#890C83",
    d: "M5 8.5h38v7H5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCA94",
    strokeWidth: 5,
    strokeDasharray: 7,
    d: "M6.5 12H43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0401);
export default __webpack_public_path__ + "static/media/icon-legend-04-01.0f2641a3202f180a6215ccfc8bc9d6d5.svg";
export { ForwardRef as ReactComponent };